/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'

const ContactPhotoSchema = new Schema({
  alt: {
    type: 'string',
    maxLength: 100
  },
  date: {
    type: 'string',
    format: 'date-time'
  },
  height: {
    type: 'number',
    min: 0
  },
  name: {
    type: 'string',
    maxLength: 100
  },
  objectKey: {
    type: 'string'
  },
  size: {
    required: true,
    type: 'number',
    min: 0
  },
  type: {
    required: true,
    type: 'string',
    maxLength: 100
  },
  url: {
    required: true,
    type: 'string',
    maxLength: 255
  },
  width: {
    type: 'number',
    min: 0
  }
})

export default ContactPhotoSchema
